import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import RedesSociales from './RedesSociales';

const API = '/api';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [busquedaAbierta, setBusquedaAbierta] = useState(false);
  const [query, setQuery] = useState('');
  const [resultados, setResultados] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const busquedaRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (busquedaAbierta) setTimeout(() => inputRef.current?.focus(), 100);
  }, [busquedaAbierta]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (busquedaRef.current && !busquedaRef.current.contains(e.target as Node)) {
        setBusquedaAbierta(false);
        setResultados([]);
        setQuery('');
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    if (query.length < 2) { setResultados([]); return; }
    const timer = setTimeout(async () => {
      setCargando(true);
      try {
        const r = await fetch(`${API}/buscador/buscar?q=${encodeURIComponent(query)}`);
        const data = await r.json();
        setResultados(data);
      } catch { setResultados([]); }
      setCargando(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const cerrarBusqueda = () => {
    setBusquedaAbierta(false);
    setResultados([]);
    setQuery('');
  };

  return (
    <nav className="sticky top-0 z-50 bg-azul border-b-4 border-rojo">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
        <Link to="/">
          <img src="https://ticobaterias.com/uploads/imagenes/logo-navbar.png"
            alt="TicoBaterías" className="h-56 w-auto object-contain" />
        </Link>

        <ul className="hidden md:flex items-center gap-3 lg:gap-6 xl:gap-8 list-none">
          {[['/', 'Inicio'], ['/catalogo', 'Productos'], ['/distribuidores', 'Distribuidores'], ['/tecnico', 'Técnico'], ['/mercadeo', 'Mercadeo'], ['/contacto', 'Contacto']].map(([path, label]) => (
            <li key={path}>
              <Link to={path} className="text-white/75 hover:text-white text-sm font-medium tracking-wide transition-colors">
                {label}
              </Link>
            </li>
          ))}
          <li className="hidden xl:flex items-center">
            <RedesSociales tamano={30} />
          </li>
        </ul>

        <div className="hidden md:flex items-center gap-3">
          {/* Buscador */}
          <div ref={busquedaRef} className="relative">
            <div className={`flex items-center gap-2 transition-all duration-300 ${busquedaAbierta ? 'bg-white/10 rounded-xl px-3 py-2' : ''}`}>
              {busquedaAbierta && (
                <input
                  ref={inputRef}
                  value={query}
                  onChange={e => setQuery(e.target.value)}
                  placeholder="Buscar marca, modelo, batería..."
                  className="bg-transparent text-white placeholder-white/50 text-sm outline-none w-56"
                />
              )}
              <button onClick={() => busquedaAbierta ? cerrarBusqueda() : setBusquedaAbierta(true)}
                className="text-white/80 hover:text-white transition-colors">
                {busquedaAbierta ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                )}
              </button>
            </div>

            {/* Resultados */}
            {busquedaAbierta && (query.length >= 2) && (
              <div className="absolute top-full right-0 mt-2 w-96 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden z-50">
                {cargando ? (
                  <div className="p-4 text-center text-gray-400 text-sm">Buscando...</div>
                ) : resultados.length === 0 ? (
                  <div className="p-4 text-center text-gray-400 text-sm">Sin resultados para "{query}"</div>
                ) : (
                  <div className="max-h-80 overflow-y-auto">
                    <div className="px-4 py-2 bg-gray-50 border-b border-gray-100">
                      <span className="text-xs font-bold text-gray-400 tracking-wider">{resultados.length} RESULTADOS</span>
                    </div>
                    {resultados.map((r, i) => (
                      <div key={i} className="px-4 py-3 hover:bg-gray-50 border-b border-gray-50 cursor-pointer transition-colors"
                        onClick={() => { const termino = r.fuente === 'producto' ? r.nombre : r.marca + ' ' + r.modelo; navigate(`/catalogo?buscar=${encodeURIComponent(termino)}&marca_auto=${encodeURIComponent(r.marca)}&modelo_auto=${encodeURIComponent(r.modelo)}&bateria=${encodeURIComponent(r.bateria)}&eq1=${encodeURIComponent(r.equivalencia1||'')}`); cerrarBusqueda(); }}>
                        <div className="flex items-start justify-between gap-2">
                          <div className="flex-1">
                            <div className="text-xs font-bold text-azul tracking-wider">{r.marca}</div>
                            <div className="text-sm font-semibold text-gray-800">{r.modelo}</div>
                          </div>
                          <div className="text-right flex-shrink-0">
                            <div className="bg-rojo text-white text-xs font-black px-2 py-1 rounded">{r.bateria}</div>
                            {r.equivalencia1 && <div className="text-xs text-gray-400 mt-1">{r.equivalencia1}</div>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <a href="tel:+50622705060" className="flex items-center gap-2 bg-rojo text-white px-4 py-2 rounded text-sm font-bold hover:bg-rojo-dark transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
            Llámenos ya
          </a>
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden text-white text-2xl">☰</button>
      </div>

      {open && (
        <div className="md:hidden bg-azul-dark px-4 pb-4">
          {[['/', 'Inicio'], ['/catalogo', 'Productos'], ['/distribuidores', 'Distribuidores'], ['/tecnico', 'Técnico'], ['/mercadeo', 'Mercadeo'], ['/contacto', 'Contacto']].map(([path, label]) => (
            <Link key={path} to={path} onClick={() => setOpen(false)} className="block text-white/75 hover:text-white py-2 text-sm font-medium">
              {label}
            </Link>
          ))}
          <RedesSociales tamano={38} className="flex items-center gap-3 pt-3 pb-1" />
          {/* Buscador móvil */}
          <div className="mt-3 relative">
            <input
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="🔍 Buscar marca, modelo, batería..."
              className="w-full bg-white/10 text-white placeholder-white/50 text-sm px-4 py-2.5 rounded-xl outline-none border border-white/20"
            />
            {query.length >= 2 && (
              <div className="mt-2 bg-white rounded-xl shadow-xl overflow-hidden">
                {cargando ? (
                  <div className="p-3 text-center text-gray-400 text-sm">Buscando...</div>
                ) : resultados.length === 0 ? (
                  <div className="p-3 text-center text-gray-400 text-sm">Sin resultados</div>
                ) : (
                  <div className="max-h-60 overflow-y-auto">
                    {resultados.map((r, i) => (
                      <div key={i} className="px-3 py-2 border-b border-gray-50" onClick={() => { const termino = r.fuente === 'producto' ? r.nombre : r.marca + ' ' + r.modelo; navigate(`/catalogo?buscar=${encodeURIComponent(termino)}&marca_auto=${encodeURIComponent(r.marca)}&modelo_auto=${encodeURIComponent(r.modelo)}&bateria=${encodeURIComponent(r.bateria)}&eq1=${encodeURIComponent(r.equivalencia1||'')}`); setOpen(false); setQuery(''); }}>
                        <div className="text-xs font-bold text-azul">{r.marca} — {r.modelo}</div>
                        <div className="text-xs text-rojo font-bold">{r.bateria}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
